import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { ToolsService } from 'src/app/services/tools/tools.service';
import { ProdComponent } from '../prod/prod.component';
import { FulleStockService } from 'src/app/services/api/fulle/fulle-stock/fulle-stock.service';
import { PanierService } from 'src/app/services/manage/panier/panier.service';
import { ProdcatService } from 'src/app/services/api/prodcat/prodcat.service';
import { TranslateService } from '@ngx-translate/core';
import { ProductService } from 'src/app/services/api/product/product.service';



@Component({
  selector: 'app-product-suggestions',
  templateUrl: './product-suggestions.component.html',
  styleUrls: ['./product-suggestions.component.css']
})
export class ProductSuggestionsComponent implements OnInit {


  merchantClient$: any;
  innerHeight: number = window.innerHeight;
  suggestions: any;
  pointOfsale: any;
  default_prod: string = "https://748073e22e8db794416a-cc51ef6b37841580002827d4d94d19b6.ssl.cf3.rackcdn.com/not-found.png";

  ButtonVisibleAddinBasket: any;
  heightpop: any

  buttonScroll: any = false;
  statusMessage: any;
  loaderpop: any;
  multiple: any = false;
  isActive: any;
  maxlengthFormule = 6;
  maxheight: any;
  height: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    public dialogRef: MatDialogRef<ProductSuggestionsComponent>,
    private tools: ToolsService,
    public media: MediaObserver,
    public dialog: MatDialog,
    private panierMan: PanierService,
    private stockApi: FulleStockService,
    private prodcatApi: ProdcatService,
    public translate: TranslateService,
    public ProductService: ProductService

  ) {


    this.suggestions = data.suggestions;

    this.merchantClient$ = data.merchantClient;
    this.pointOfsale = this.tools.getStor("point_of_sale");


    //test
    //  this.pointOfsale.webshop_display_mode = 1;


  }

@HostListener('window:resize', ['$event'])
  onResize(event: any) {
   this.innerHeight= window.innerHeight;
      this.buttonVisibleScroll();
    this.setContentHeight("resize");
  }
  ngOnInit(): void {
    this.innerHeight= window.innerHeight;
    // set button scroll  
    this.buttonVisibleScroll();
    this.setContentHeight("start");
    

  }





  /**
   * @description set Product Selected
   * @params prod
   */
  setProductSelected(prod: any, suggestion_id?: any) {




    this.suggestions.forEach((element: any) => {


      if (element.products_exist_suggestions_list) {

        element.products_exist_suggestions_list.forEach((value: any) => {

          if (value.products && value.products.length > 0) {
            value.products.forEach((val: any) => {


              if (suggestion_id == element.id && !this.multiple && val.productSuggeAdded && val.rubric && prod.rubric && (val.rubric.id == prod.rubric.id)) {
                val.productSuggeAdded = false;
                val.productToAdd = null;

              }

              if (suggestion_id == element.id && val.id == prod.id && !val.productSuggeAdded) {
                val.productSuggeAdded = true;
                val.productToAdd = prod;

              }

            })
          }
        })
      }



    });

    this.setContentHeight("add");
    this.visibleButtonAddInBasket();

  
  }


  /**
 * @description setContentHeight after add chips or remove chips
 */
  setContentHeight(provena: any) {


    setTimeout(() => {

      let dialogcontent = document.getElementById('#popupCont');
      let chipsProducts = document.getElementById('chipsProducts');
      if (dialogcontent && chipsProducts) {
        this.maxheight = this.height - chipsProducts.getBoundingClientRect().height;
     
       
      }
    }, 0);

  }

  /**
  * @description visibleButtonAddInBasket button
  */
  visibleButtonAddInBasket() {
    this.ButtonVisibleAddinBasket = false;

    this.suggestions.forEach((element: any) => {
      if (element.products_exist_suggestions_list) {

        element.products_exist_suggestions_list.forEach((value: any) => {

          if (value.products && value.products.length > 0) {
            value.products.forEach((val: any) => {
              if (val.productSuggeAdded) {
                this.ButtonVisibleAddinBasket = true;
              };
            })
          }
        })
      }


    });
  }


  /**
   * @description get categories Prod
   * @params prod
   */

  getcatProd(prod: any, suggestion_id?: any) {


    this.loaderpop = true;
    this.statusMessage = this.translate.instant('loaderCats')

    this.prodcatApi.getApiProdCatsByIdProd(prod).subscribe((cats) => {
      cats = this.checkCategories(cats);
      prod.categories = cats;
      prod.novisible = prod.categories && prod.categories.length > 0 ? false : true;
      this.loaderpop = false;
      this.statusMessage = null;
        // this.ProductService.setObserProductTypeformule(prod.product_type == 2?true:false);
      this.openDialProdComp(prod, cats, suggestion_id);
    });

  }

  /**
   * @description checkCategories
   * @params cats
   */
  checkCategories(cats: any) {



    let newCats: any = [];
    if (cats && cats.length > 0) {
      cats.forEach((element: any) => {
        let detailsCats: any = []
        if (element && element.details && element.details.length > 0) {
          element.details.forEach((details: any) => {
            if (details.product && details.product.product_type < 2) {
              detailsCats.push(details);
            }
          });
          if (detailsCats && detailsCats.length > 0) {
            element.details = detailsCats;
            newCats.push(element);
          }
        }
      });
    }

    return newCats;

  }


  /**
  * @description openDial check if clicked and categories
  * @params prod
  * @params ?categories
  */
  openProdDial(prod: any, suggestion_id?: any) {


    if (prod.productSuggeAdded && prod.productToAdd && prod.suggestion_id && prod.suggestion_id == suggestion_id) {

      prod.productSuggeAdded = false;
      prod.productToAdd = null;
      this.setContentHeight("remove");
      this.visibleButtonAddInBasket();
      return;
    }


    prod.product_type > 0 ? this.getcatProd(prod, suggestion_id) : this.setProductSelected(prod, suggestion_id);


  }

  /**
  * @description openDial Prod Composant
  * @params prod
  * @params ?categories
  */

  openDialProdComp(prod: any, categories?: any, suggestion_id?: any): void {

    const myConf = new MatDialogConfig();

    if (this.media.isActive('xs')) {
      myConf.panelClass = 'full-screen';
    } else {
      myConf.width = prod.product_type === 2 ? "780px" : "450px";
      myConf.maxHeight = '700px';

    }

    myConf.autoFocus = false;
    myConf.data = {
      from: 'add',
      prod: prod,
      productSuggested: this.multiple ? false : true,
      merchantClient: this.merchantClient$ ? this.merchantClient$ : null,
      categories: categories
    };



    const myDial = this.dialog.open(ProdComponent, myConf);
    myDial.afterClosed().subscribe((result) => {
  
      if (result) {
        this.setProductSelected(result, suggestion_id);
      }
     

    })
  }

  /**
  * @description set Products Suggested
  */
  validProductsSuggested() {
    let products: any = []
    this.suggestions.forEach((element: any) => {

      if (element.products_exist_suggestions && element.products_exist_suggestions.length > 0) {
        element.products_exist_suggestions.forEach((val: any) => {
          if (val.productSuggeAdded) {
            products.push(val.productToAdd);
          };

        })
      }
    });



    //add panier
    if (products && products.length > 0)
      products.forEach((element: any) => {
        //stocks
        if (element.stock && element.stock.count && element.stock.count > 0) {
          element.stock.count -= element.quantity;
          this.stockApi.stocks[element.id.toString()].count = element.stock.count;
        }

        // add to basket
        this.panierMan.manageProduct(element, this.stockApi.stocks);

        //change stok in view
        if (element.stock) {
          this.stockApi.setCurrStock(element.id, element.stock.count);
        }
      })

    this.closeDial();
  }






  /**
 * @description close Dialog
 */
  closeDial() {

    this.dialogRef.close();
  }


  /**
   * @description buttonVisibleScroll
     */
  buttonVisibleScroll() {
    //calcul button for scroll
    setTimeout(() => {
      let popupCont = document.getElementById('#popupCont');
      let title = document.getElementById('title');
      let buttonB = document.getElementById('buttonB');
      if (popupCont && title && buttonB) {
        this.buttonScroll = popupCont.getBoundingClientRect().bottom > this.innerHeight -
          title.clientHeight - buttonB.clientHeight ? true : false;

        this.height = this.innerHeight - title.clientHeight - buttonB.clientHeight;
      
      }

    }, 0);


  }

  /**
   * @description   scroll
   
   */
  scroll() {

    setTimeout(() => {
      let index = this.suggestions.length >= this.maxlengthFormule ? this.maxlengthFormule - 1 : this.suggestions.length - 1;

      const elmnt2 = document.getElementById("id_" + index);

      if (elmnt2) {
        elmnt2.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
      }

    }, 0);


  }


  scrolltoprod(prod: any) {

    let id = "prod_" + prod.id + "_" + prod.suggestion_id;
    const elmnt = document.getElementById(id);

    if (elmnt) {

      elmnt.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest"
      });
    }
  }
  setButton(index: any) {

    this.isActive = index;
    let id = "id_" + index
    const elmnt = document.getElementById(id);

    const elmnt2 = document.getElementById("#popupCont");


    if (elmnt && elmnt2) {

      elmnt.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest"
      });
    }



  }
}
